import React from 'react';
import PropTypes from 'prop-types';

import './radio.scss';

function Radio({ label, containerClassName, ...props }) {
  return (
    <label className={containerClassName || 'ui-radio-container'}>
      <input type="radio" className="ui-radio" {...props} />
      <p className="ui-radio-label">{label}</p>
    </label>
  );
}

Radio.propTypes = {
  label: PropTypes.string,
  containerClassName: PropTypes.string,
};

export default Radio;
